export const ORDER_IN_QUEUE_MESSAGE = "Xook will start your orders in some time.";
export const ORDER_IN_PROGRESS_MESSAGE = "Xook is currently preparing your dishes."